// extracted by mini-css-extract-plugin
export default {"links":"PoliciesLinks_links__-tt+z","link":"PoliciesLinks_link__2bZJL"};